import { MemoryFs } from "./MemoryFs";

let fsHandler:FileSystemInterface = new MemoryFs();

export function setFileSystemTool(fs:FileSystemInterface) {
  fsHandler = fs;
}

export function getFileSystemTool() {
  return fsHandler;
};

export enum EncodingType {
    UTF8 = 'utf8',
    Base64 = 'base64',
}

export type ReadingOptions = {
    encoding?: EncodingType | 'utf8' | 'base64';
    position?: number;
    length?: number;
};

export type WritingOptions = {
    encoding?: EncodingType | 'utf8' | 'base64';
};

export type DownloadOptions = {
  md5?: boolean;
  cache?: boolean;
  headers?: Record<string, string>;
};

export type FileSystemHttpResult = {
    headers: Record<string, string>;
    status: number;
    mimeType: string | null;
  };

export type FileSystemDownloadResult = FileSystemHttpResult & {
  uri: string;
  md5?: string;
};

export type getInfoOptions = {
    md5?: boolean; 
    size?: boolean
}

export type FileInfo =
  | {
      exists: true;
      uri: string;
      size: number;
      isDirectory: boolean;
      modificationTime: number;
      md5?: string;
    }
  | {
      exists: false;
      uri: string;
      size: undefined;
      isDirectory: false;
      modificationTime: undefined;
      md5: undefined;
    };

export interface FileSystemInterface {
    documentDirectory:string;
    getInfoAsync(
        fileUri: string,
        options?: { md5?: boolean; size?: boolean }
    ): Promise<FileInfo>;
    downloadAsync(uri: string, fileUri: string, options?: DownloadOptions): Promise<FileSystemDownloadResult>;
    moveAsync(options: { from: string; to: string }): Promise<void>;
    copyAsync(options: { from: string; to: string }): Promise<void>;
    writeAsStringAsync(fileUri: string, contents: string, options?: WritingOptions): Promise<void>;
    readAsStringAsync(fileUri: string, options?: ReadingOptions): Promise<string>;
    deleteAsync(
      fileUri: string,
      options?: { idempotent?: boolean }
    ): Promise<void> ;
}